import React, {useContext} from 'react';
import {Modal, ModalProps} from 'antd';
import {ConfigContext} from '../../../ConfigProvider';
import classNames from 'classnames';
import styles from './index.module.scss';
import ModalSpin from '../ModalSpin';
import Boundary from 'Components/Boundary';

export interface LargeModalProps extends ModalProps {}

const LargeModal: React.FC<LargeModalProps> = ({
    className,
    children,
    ...extraProps
}) => {
    const {topOffset, containerWidth} = useContext(ConfigContext);

    return (
        <Modal
            className={classNames(styles.root, className)}
            width={containerWidth}
            style={{top: topOffset}}
            {...extraProps}>
            <Boundary spinner={<ModalSpin />}>{children}</Boundary>
        </Modal>
    );
};

export default LargeModal;
